import { render, staticRenderFns } from "./business-card.vue?vue&type=template&id=53bba8dc&scoped=true&"
import script from "./business-card.vue?vue&type=script&lang=js&"
export * from "./business-card.vue?vue&type=script&lang=js&"
import style0 from "./business-card.vue?vue&type=style&index=0&id=53bba8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bba8dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VCard,VIcon})
